import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledMenuChevronRightIcon = styled(Box)(({ theme }) => ({
  '--s': '2px', /* control the shape (can be percentage) */
  height: '10px',
  marginLeft: '2px',
  aspectRatio: '3/5',
  clipPath: 'polygon(0 0, var(--s) 0, 100% 50%, var(--s) 100%, 0 100%, calc(100% - var(--s)) 50%)',
  background: theme.palette.text.primary,
  opacity: 0.5,
}));

export default StyledMenuChevronRightIcon;
